module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"about":"ABOUT"},"tr":{"about":"HAKKINDA"}}')
  delete Component.options._Ctor
}
